// extracted by extract-css-chunks-webpack-plugin
module.exports = {"hover":"_2qbQag","underline":"_127tdO","headerVariant":"_2t8CrI"};